import { Indicator } from '../../../Common/Charts/Indicator';
import { useGeneralResultsChartsDataContext } from './hooks/useGeneralResultsChartsDataContext';

export const TenagerMothers = () => {
    const { chartData } = useGeneralResultsChartsDataContext();

    return (
        <Indicator
            title={'Nascidos Vivos com Anomalia'}
            indicatorValue={chartData?.indicators?.tenagerMothers}
            className='aligned-container'
        />
    );
};
